import { SxProps } from '@mui/material';
import { black, grey, grey4, grey6 } from 'app/components/ThemeProvider/colors';
import { CSSProperties } from 'react';

export const infoText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '26px',
  mb: '12px',
  fontWeight: '600',
};

export const btnBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
};

export const formGroup: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
};
export const radioGroup: SxProps = {
  height: '392px',
  mb: '12px',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'row',

  '&::-webkit-scrollbar': {
    width: '7px',
  },

  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },

  '&::-webkit-scrollbar-thumb': {
    borderRadius: '10px',
    background: grey6,
  },
};

export const companyBox: SxProps = {
  p: '16px 18px',
  border: `1px solid ${grey4}`,
  borderRadius: '12px',
  mb: '16px',
  display: 'flex',
  alignItems: 'flex-start',
  width: '100%',
  ml: 0,
  mr: '14px',
  height: 'fit-content',

  '& .MuiRadio-root': {
    padding: '0 !important',
    mr: '12px',
  },

  '& .Mui-disabled': {
    opacity: 0.4,
  },
};

export const voenText: SxProps = {
  fontFamily: 'Yelo',
  color: grey,
  fontSize: '14px',
  textTransform: 'uppercase',
};

export const companyName: SxProps = {
  fontFamily: 'Yelo',
  color: black,
  fontSize: '16px',
  textTransform: 'uppercase',
};

export const signType: SxProps = {
  fontFamily: 'Yelo',
  color: grey,
  fontSize: '14px',
  mt: '12px',
  display: 'flex',
  alignItems: 'flex-start',
};
